import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { PrimaryButton, LightButton, Forbidden } from '../../../components';

import styles from '../Modals.module.css';

export const EliminarPacienteModal = ({ hide, eliminar }) => {

  const { permisos } = useSelector(state => state.auth);

  return (permisos.pacienteDelete) ? (
    <div>
      <div className="row">
        <div className="col">
          <div className={styles.modalHeader}>Eliminar paciente</div>
        </div>
      </div>
      <div className="row">
        <div className="col">
            <div className="row">
              <div className="col mt-3 mb-3">
                <p>Al eliminar un paciente ya no será posible recuperar su información. ¿Desea continuar?</p>
              </div>
            </div>
            <div className="row">
              <div className="col-xs-12 col-sm-12 col-md-6">
                <LightButton
                  block={true}
                  icon="X"
                  marginTop={false}
                  onClick={ hide }
                  text="Cancelar"
                  type="button"
                />
              </div>
              <div className='col-xs-12 col-sm-12 col-md-6'>
                <PrimaryButton
                  block={true}
                  icon="Check"
                  marginTop={false}
                  onClick={ eliminar }
                  text="Continuar"
                  type="button"
                />
              </div>
            </div>
        </div>
      </div>
    </div>
  ) : <Forbidden />
}

EliminarPacienteModal.propTypes = {
  hide: PropTypes.func.isRequired,
  eliminar: PropTypes.func.isRequired,
}